
import React from 'react';
import NonFSIndex from "@dndComponents/NonFSIndex";

export default function GameDeckIndex() {
  return (
    <NonFSIndex
      data_type="game_deck"
    />
  );
}
